import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { getUnique } from '../../../helpers/common'
import { useHandshakesWidget } from '../../common/widget/useHandshakesWidget'
import { FILTER_BY } from '../../constant'
import { createConnectionMapLogs } from '../../store/thunk'
import { changeLoading, changeRequestId, selectLoading } from '../store/slice'
import { DegreeSelect } from './DegreeSelect'

const RadialMapTab = ({ filterBy, filter = {} }) => {
  const dispatch = useDispatch()
  const { graphType, searchCompany, searchPerson, degree } = filter
  const loading = useSelector(selectLoading('radial'))
  const widgetInstance = useHandshakesWidget('#hs-widget-radial-map')

  useEffect(() => {
    if (
      widgetInstance &&
      (searchCompany?.organizationId || searchPerson?.personId)
    ) {
      const id = getUnique()
      const datasets = ['CRVN']
      const entities = [
        {
          dataset: 'CRVN',
          id:
            filterBy === FILTER_BY.COMPANY
              ? `O-${searchCompany?.organizationId}`
              : `P-${searchPerson?.personId}`,
        },
      ]
      dispatch(
        createConnectionMapLogs({
          requestId: id,
          graphType,
          datasets: JSON.stringify(datasets),
          entities: JSON.stringify(entities),
          degree,
        }),
      )
      dispatch(changeRequestId({ [graphType]: id }))
      dispatch(changeLoading({ radial: true }))
      widgetInstance.drawGraphWithEndpointData({
        graphType,
        datasets,
        entities,
        degree,
      })
    }
  }, [
    graphType,
    searchCompany?.organizationId,
    searchPerson?.personId,
    degree,
    widgetInstance,
  ])

  if (!searchCompany?.organizationId && !searchPerson?.personId) {
    return (
      <Element
        className="textCenter pt5 fw500"
        style={{ fontSize: 20, color: '#9C9C9C' }}
      >
        <Translate value="connectMap.entityMap.PLEASE_SELECT" />
      </Element>
    )
  }

  return (
    <>
      {!loading && <DegreeSelect />}
      <div id="hs-widget-radial-map" className="h100" />
      {loading && <Loading style={{ background: '#fff' }} />}
    </>
  )
}

export default RadialMapTab
